import {
  ENDPOINT_CARTS,
  ENDPOINT_ITEMS,
  ENDPOINT_QUOTES,
  ENDPOINT_QUOTES_DRAFT,
  ENDPOINT_QUOTES_INSTALLER,
  ENDPOINT_ROOT,
  ENDPOINT_WISHLISTS,
  ITEM_TYPES,
  QUOTE_TYPES,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

/**
 * Post to Add Items to a target given with his type
 * @param {array} items
 * @param {object} target
 * @param {string} type
 * @returns {Promise<AxiosResponse<any>>}
 */
const postTypeItems = ({ items, target, type }) => {
  // Set typeEndpoint to cart by default
  let typeEndpoint = ENDPOINT_CARTS;

  // If import is a type of quote, determine if it is a draft or an installer
  if (
    type === ITEM_TYPES.quotes ||
    type === ITEM_TYPES.installer ||
    type === ITEM_TYPES.draft
  ) {
    switch (target.id.substr(0, 1)) {
      case QUOTE_TYPES.letter.draft:
        typeEndpoint = ENDPOINT_QUOTES_DRAFT;
        break;
      case QUOTE_TYPES.letter.installer:
        typeEndpoint = ENDPOINT_QUOTES_INSTALLER;
        break;
      default:
        typeEndpoint = ENDPOINT_QUOTES;
        break;
    }
  } else if (type === ITEM_TYPES.wishlists) {
    typeEndpoint = ENDPOINT_WISHLISTS;
  }

  const params = { items: [...items] };

  return axiosAuth
    .post(
      `${ENDPOINT_ROOT}/${typeEndpoint}/${target.id}/${ENDPOINT_ITEMS}`,
      params,
    )
    .then((res) => res);
};

export default postTypeItems;
